


















































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../components/MonthSelector.vue";
import OtherInvoiceTypes from "../data/OtherInvoiceTypes"
import DepartList from "../data/DepartList"

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
    }
})
export default class AddOtherBill extends Vue {
    canEditIndex: number = -1
    writtenPerson: string = ""
    total: string = ""  //总计
    typeList = OtherInvoiceTypes;
    deptList = DepartList;
    mounted() {
    }
    // 获取时间范围
    get options() {
        return {
            disabledDate: (time: Date) => {
                let cur: string = this.period.substring(0, 4) + "-" + this.period.substring(4),
                    start: Date = new Date(cur + "-" + "01"),
                    end: Date = this.getCurrentMonthLast(new Date(cur));
                return time.getTime() > end.getTime();
            }
        }
    };
    getCurrentMonthLast(date: Date) {//获取下拉时间选择的范围
        let currentMonth: number = date.getMonth();
        let nextMonth: number = ++currentMonth;
        let nextMonthFirstDay: any = new Date(date.getFullYear(), nextMonth, 1);
        let oneDay: number = 1000 * 60 * 60 * 24;
        return new Date(nextMonthFirstDay - oneDay);
    }
    // 获取表格数据
    otherList: OtherBill.OtherBill[] = []
    listCopy: OtherBill.OtherBill[] = []
    fetchData() {
        Vue.axios
            .get(`otherinvoices?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}&page=${this.currentPage - 1}&size=${this.pageSize}`)
            .then(res => {
                res.data.others.content.forEach((v: OtherBill.OtherBill) => {
                    v.writtenDate = this.transDate(v.writtenDate);
                    v.checked = false;
                })
                this.otherList = res.data.others.content;
                this.total = res.data.totalMoney;
                this.totalElements = res.data.others.totalElements;
                for (let i = 0; i < this.otherList.length; i++) {
                    this.listCopy.push(JSON.parse(JSON.stringify(this.otherList[i])))
                }
            });
    }
    // 修改 writtenDate 
    transDate(date: string | Date) {
        if (typeof (date) === "string") {
            let year = date.substr(0, 4),
                month = date.substr(4, 2),
                day = date.substr(6);
            return new Date(`${year}-${month}-${day}`);
        } else {
            return this.$utils.simpleDateFormat(date, "d", true);
        }
    }
    //改变时间
    period: string = ""; // 日期
    changeDate(date: string, ) {
        this.period = date;
        this.fetchData();
    }
    //新增 可用
    newDate: Date | string = new Date(this.period.substring(0, 4) + "-" + this.period.substring(4));
    newAttach: string = "";
    newType: string = <string>this.typeList[1].id;
    newCash: string = "";
    newDept: string = <string>this.deptList[0].id;
    newRemark: string = "";

    curRow: OtherBill.OtherBill | null = null;
    // 判断是否显示的
    get isClose() {
        let close = this.$store.state.accountBook.closePeriod;
        if (close != null && this.period != "") {
            let closeDate = new Date(close.substr(0, 4) + "-" + close.substr(4)),
                curPeriod = new Date(this.period.substr(0, 4) + "-" + this.period.substr(4));
            return curPeriod <= closeDate
        } else return false
    }
    // 分页
    pageSize: number = 20;
    currentPage: number = 1;
    totalElements: number = 0;
    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.fetchData();
    }
    // 批量删除全选
    checkAll: boolean = false;
    delButton: string = "批量删除";
    notAllow: boolean = false;
    selectAll(val: boolean) {
        this.otherList.forEach((v: any) => {
            v.checked = val;
        })
    }
    lotDelete() { // 删除按钮切换
        if (!this.notAllow) {
            this.delButton = "取消";
            this.notAllow = true;
        } else {
            if (this.delButton === "删除") {
                this.deleteRows();
            } else {
                this.delButton = "批量删除";
                this.notAllow = false;
                this.clearCheck();
            }
        }
    }
    clearCheck() { //清除全选删除 
        this.otherList.forEach((v: any) => {
            if (v.checked) v.checked = false;
        });
    }
    //下拉选中
    select(e: any) { e.target.select(); }
    // 删除 数据行
    deleteRows() {
        let val: string[] = [];
        this.otherList.forEach((v: any) => {
            if (v.checked) val.push(v.id);
        })
        this.$confirm(`亲，您选中了 ${val.length} 条日记账，是否确认删除？`, "温馨提示").then((action: any) => {
            if (action === "confirm") {
                Vue.axios
                    .delete(`otherinvoices?id=${val}`, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
                    .then(res => { this.delButton = "批量删除"; this.notAllow = false; this.fetchData() });
            }
        })
    }
    deleteRow(id: string) {
        this.$confirm("亲，确定删除吗？", "温馨提示").then((action: any) => {
            if (action === "confirm") {
                Vue.axios
                    .delete(`otherinvoices?id=${id}`, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
                    .then(res => { this.fetchData() });
            }
        })
    }
    // 
    editThisRow(index: number, e: any) {
        if (!this.isClose) {
            this.canEditIndex = index;
            this.$nextTick(() => {
                for (let i = 0; i < e.path.length; i++) {
                    if (e.path[i].nodeName === "TD") {
                        e.path[i].querySelector("input").focus();
                        break;
                    }
                }
            })
        }
    }
    // 失去焦点离开
    blurNow(row: OtherBill.OtherBill) {
        if (this.curRow != row) this.curRow = row;
    }
    // 新增行 失去焦点
    blurNew(e: TextEvent) {
        setTimeout(() => {
            if ((<HTMLElement>document.activeElement).getAttribute("name") != "newTr") {
                this.leaveRow(1)
            }
        }, 50)
    }
    // 监听canEditIndex
    @Watch("canEditIndex")
    canEditIndexChanged(val: number, before: number) {
        if (before != -1) {
            this.leaveRow(2, this.curRow, before);
        }
    }
    // 监听表格获取数据 判断是否全选删除
    @Watch("otherList", { deep: true })
    listChange(val: OtherBill.OtherBill[]) {
        if (val.length === 0) this.newDate = new Date(this.period.substring(0, 4) + "-" + this.period.substring(4));
        else this.newDate = val[val.length - 1].writtenDate;

        let all = true,
            hasSelect = false;
        val.forEach((v: any) => {
            if (!v.checked) all = false;
            else hasSelect = true;
        });
        this.checkAll = all;
        if (hasSelect) this.delButton = "删除";
        else if (this.delButton === "删除") this.delButton = "取消";
    }
    leaveRow(type: number, row?: any, before?: any) {
        if (type === 1) {
            if (String(this.newType) != "" && this.newCash != "") {
                this.addRequest();
            }
        } else {
            let beRow: OtherBill.OtherBill = this.listCopy[before];
            if (new Date(beRow.writtenDate).toString() != new Date(row.writtenDate).toString() || beRow.invoiceType != row.invoiceType || beRow.money != row.money || beRow.accessoryNo != row.accessoryNo || beRow.department != row.department || beRow.remark != row.remark) {
                this.editRequest(row);
            }
        }
    }
    // 清除新增行
    clearNew() {
        this.newAttach = this.newRemark = this.newCash = "";
        this.newType = <string>this.typeList[1].id;
    }
    // 新增行
    addRequest() {
        Vue.axios
            .post(`otherinvoices`, {
                accountBookId: this.$store.state.accountBook.id,
                writtenDate: this.$utils.simpleDateFormat(<Date>this.newDate, "d"),
                money: this.newCash,
                accessoryNo: this.newAttach,
                department: this.newDept,
                writtenPerson: this.writtenPerson,
                period: this.period,
                remark: this.newRemark,
                invoiceType: this.newType
            })
            .then(res => {
                this.clearNew();
                this.fetchData()
            });

    }
    // 修改行
    editRequest(row: OtherBill.OtherBill) {
        let rowCopy = JSON.parse(JSON.stringify(row));
        rowCopy.writtenDate = this.$utils.simpleDateFormat(new Date(rowCopy.writtenDate), "d");
        Vue.axios.put(`otherinvoices`, rowCopy).then(res => { this.fetchData() });
    }

    pressEnter(e: KeyboardEvent, isNumber?: boolean, isLast?: boolean) {
        this.$utils.arrowPress(e, isNumber);
        if (isLast && (e.keyCode === 13 || e.keyCode === 9)) {
            if (this.canEditIndex === -1) this.leaveRow(1);
            else this.canEditIndex = -1;
        }
    }
}
